<template>
  <el-dialog title="角色选择" width="70%" top="4vh" :before-close="close" :visible.sync="config.dialogVisible">
    <el-container>
      <el-main class="table-main">
        <el-form :model="form" label-width="90px" size="mini">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.info.user.RuleCode')">
                <el-input v-model="form.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.user.RuleName')">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.Type')">
                <el-select v-model="form.type">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button icon="el-icon-search" @click="search('refresh')" size="mini" style="margin-left: 5px;">{{$t('common.Search')}}</el-button>
              <el-button icon="el-icon-refresh-left" @click="form = {}" size="mini">{{$t('common.Reset')}}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="roleUrlList" border stripe ref="roleUrlList" @selection-change="selectChange">
          <el-table-column type="selection" width="40%">
          </el-table-column>
          <el-table-column :label="$t('common.No')" width="55%" type="index">
          </el-table-column>
          <el-table-column prop="code" :label="$t('common.Code')" align="center" width="100%">
          </el-table-column>
          <el-table-column prop="name" :label="$t('common.Name')" align="left">
          </el-table-column>
          <el-table-column prop="type" :label="$t('common.Type')" width="180%" align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.type===50" size="small">{{$t('base.info.user.OnlineRegister')}}</span>
              <span v-if="scope.row.type===20" size="small">{{$t('base.info.user.Custom')}}</span>
              <span v-if="scope.row.type===10" size="small">{{$t('base.info.user.SystemRetention')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('common.Status')" align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.status===50">{{$t('common.Normal')}}</span>
              <span v-if="scope.row.status===40">{{$t('common.Disable')}}</span>
              <span v-if="scope.row.status===10">{{$t('common.Draft')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="table-footer">
        <el-row>
          <el-col :span="18">
            <table-page ref="roleUrlListPage" :url="roleUrl" :form="form" @page-change="convert"></table-page>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="mini" @click="confirm">{{$t('common.Ok')}}</el-button>
            <el-button size="mini" @click="close">{{$t('common.Cancel')}}</el-button>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-dialog>
</template>

<script>
import TablePage from '@/components/TablePage'
export default {
  props: {
    config: {},
    initSelection: {}
  },
  data () {
    return {
      options: [{label: this.$t('common.PleaseChoose')}, {value: 10, label: this.$t('base.info.user.OnlineRegister')}, {value: 20, label: this.$t('base.info.user.Custom')}, {value: 50, label: this.$t('base.info.user.SystemRetention')}],
      form: {
        'executePrice': this.config.executePrice || ''
      },
      roleUrl: this.global.BASE_ACL + '/role/findAllRole',
      roleUrlList: [],
      roleUrlConfig: this.config,
      multipleSelection: [],
      initSelected: []
    }
  },
  components: {
    TablePage
  },
  methods: {
    search (param) {
      this.$refs['roleUrlListPage'].getTableData(param)
    },
    selectChange (selection) { // 根据id记住选中行(分页会清空选中行bug)
      setTimeout(() => { // 关键操作，设置一个延时，让update初始化选中里面的循环跑完再执行这里的操作，不然会gg
        selection.forEach(item => { // 新选中的行，push进选中列表
          let newFlag = this.multipleSelection.some(i => {
            return i.id == item.id
          })
          if (!newFlag) {
            this.multipleSelection.push(item)
          }
        })
        this.multipleSelection.forEach((item, index) => { // 被取消选中的行(需判断是否是本页数据)
          let pageFlag = this.roleUrlList.some(i => {
            return i.id == item.id
          })
          let existFlag = selection.some(i => {
            return i.id == item.id
          })
          if (pageFlag && !existFlag) { // 是本页数据并且没有选中，pop出选中列表
            this.multipleSelection.splice(index, 1)
          }
        })
      }, 200)
    },
    convert (tableData) {
      this.roleUrlList = tableData.data
    },
    close () {
      this.roleUrlConfig.dialogVisible = false
      this.$emit('update:roleUrlConfig', this.roleUrlConfig)
    },
    confirm () {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择菜单Url',
          center: true
        })
        return false
      }
      if (!this.roleUrlConfig.isMulti && this.multipleSelection.length > 1) { // 判断单选
        this.$message({
          message: '请最多选择一个Url',
          center: true
        })
        return false
      }
      this.$emit('confirm', this.multipleSelection)
      this.roleUrlConfig.dialogVisible = false
    }
  },
  updated () {
    this.initSelected = this.initSelection
    this.form.executePrice = this.config.executePrice
    this.$refs['roleUrlList'] && this.$refs['roleUrlList'].clearSelection()
    // const init_arr = this.multipleSelection.concat(this.initSelected) // 数组合并
    // this.multipleSelection = Array.from(new Set(init_arr)) // 数组去重
    if (this.initSelected && this.initSelected.length > 0) { // 初始化
      this.multipleSelection = this.initSelected.slice(0)
      this.initSelected = []
    } else {
      this.multipleSelection = []
    }
    this.multipleSelection.forEach(row => {
      this.roleUrlList.some(item => {
        if (item.id == row.id) {
          this.$refs['roleUrlList'].toggleRowSelection(item)
        }
      })
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RoleSelect.vue